import React from 'react';
import type { LayoutProps } from './types';
import { ImageItem } from './ImageItem';

export const MasonryLayout: React.FC<LayoutProps> = ({
  filteredItems,
  colors,
  data,
  imageRefs,
  onImageClick,
}) => {
  const columnCount = Math.min(data.columns, filteredItems.length);
  const columnGap =
    data.spacing === 'compact' ? '0.5rem' : data.spacing === 'spacious' ? '1.5rem' : '1rem';

  return (
    <div
      className="columns-1"
      style={{
        columnCount: columnCount > 1 ? columnCount : 1,
        columnGap,
      }}
    >
      {filteredItems.map((item, index) => (
        <div key={item.id} className="break-inside-avoid mb-4">
          <ImageItem
            item={item}
            index={index}
            isMasonry
            lightboxEnabled={data.lightbox}
            lazyLoading={data.lazyLoading}
            captionPosition={data.captionPosition}
            aspectRatio={data.aspectRatio}
            captionColor={colors.captionColor}
            imageRefs={imageRefs}
            onImageClick={onImageClick}
          />
        </div>
      ))}
    </div>
  );
};
